import { css } from 'lit';

export const alertStyles = css`
  sl-alert::part(base) {
    color: var(--sl-color-neutral-950);
  }
`;
